module.exports = __webpack_public_path__ + "static/media/friends-dark.faaf0c46.svg";